import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Integrations = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        width={size}
        height={size}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.98438 4.40625C1.98438 5.23468 2.65595 5.90625 3.48438 5.90625C4.3128 5.90625 4.98438 5.23468 4.98438 4.40625C4.98438 3.57782 4.3128 2.90625 3.48438 2.90625C2.65595 2.90625 1.98438 3.57782 1.98438 4.40625ZM0.984375 4.40625C0.984375 5.78696 2.10366 6.90625 3.48438 6.90625C3.66628 6.90625 3.84365 6.88682 4.01452 6.84993L6.13857 10.6636C5.71835 11.1108 5.46094 11.7129 5.46094 12.375C5.46094 13.7557 6.58023 14.875 7.96094 14.875C9.34165 14.875 10.4609 13.7557 10.4609 12.375C10.4609 11.7387 10.2233 11.158 9.83183 10.7167L11.9776 6.86404C12.1267 6.89176 12.2804 6.90625 12.4375 6.90625C13.8182 6.90625 14.9375 5.78696 14.9375 4.40625C14.9375 3.02554 13.8182 1.90625 12.4375 1.90625C11.1722 1.90625 10.1264 2.84625 9.96046 4.06602L5.96142 4.06603C5.79545 2.84626 4.74969 1.90625 3.48438 1.90625C2.10366 1.90625 0.984375 3.02554 0.984375 4.40625ZM5.89639 5.06603C5.74259 5.62962 5.39653 6.11388 4.93306 6.44397L6.96008 10.0834C7.26654 9.94936 7.60505 9.875 7.96094 9.875C8.34114 9.875 8.70151 9.95987 9.02416 10.1117L11.0452 6.48299C10.5534 6.15264 10.1855 5.65225 10.0255 5.06602L5.89639 5.06603ZM10.9375 4.40625C10.9375 5.23468 11.6091 5.90625 12.4375 5.90625C13.2659 5.90625 13.9375 5.23468 13.9375 4.40625C13.9375 3.57782 13.2659 2.90625 12.4375 2.90625C11.6091 2.90625 10.9375 3.57782 10.9375 4.40625ZM7.96094 13.875C7.13251 13.875 6.46094 13.2034 6.46094 12.375C6.46094 11.5466 7.13251 10.875 7.96094 10.875C8.78936 10.875 9.46094 11.5466 9.46094 12.375C9.46094 13.2034 8.78936 13.875 7.96094 13.875Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default Integrations
